import type { CarbonMethodology } from "@/mocks/carbono";

interface MethodologyCardProps {
  methodology: CarbonMethodology;
}

export default function MethodologyCard({ methodology }: MethodologyCardProps) {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-5 hover:-translate-y-1 hover:border-primary-300/70 transition-all duration-300">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${methodology.status === "ativa" ? "bg-primary-50" : "bg-background-100"}`}>
            <i className={`ri-calculator-line ${methodology.status === "ativa" ? "text-primary-600" : "text-foreground-400"} w-full h-full flex items-center justify-center text-lg`} />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 leading-tight">{methodology.name}</h3>
            <div className="text-[11px] text-foreground-500">{methodology.type}</div>
          </div>
        </div>
        <span
          className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-[11px] font-medium border ${
            methodology.status === "ativa"
              ? "bg-primary-50 text-primary-700 border-primary-200"
              : "bg-background-100 text-foreground-400 border-background-200"
          }`}
        >
          <i className={`${methodology.status === "ativa" ? "ri-check-line" : "ri-close-line"} w-3 h-3 flex items-center justify-center`} />
          {methodology.status === "ativa" ? "Ativa" : "Inativa"}
        </span>
      </div>

      <p className="text-xs text-foreground-600 mb-3 leading-relaxed">{methodology.description}</p>

      <div className="space-y-2 mb-3">
        <div className="text-[11px] text-foreground-500 font-medium">Dados necessários:</div>
        <div className="flex flex-wrap gap-1.5">
          {methodology.requiredData.map((item) => (
            <span key={item} className="px-2 py-0.5 bg-background-50 text-[11px] text-foreground-600 rounded-md border border-background-200">
              {item}
            </span>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-3">
        <div className="bg-background-50 rounded-lg p-2">
          <div className="text-[10px] text-foreground-400 mb-0.5">Precisão</div>
          <div className="text-xs font-semibold text-foreground-700">{methodology.precisionLevel}</div>
        </div>
        <div className="bg-background-50 rounded-lg p-2">
          <div className="text-[10px] text-foreground-400 mb-0.5">Limitação</div>
          <div className="text-xs text-foreground-600 line-clamp-2">{methodology.limitations}</div>
        </div>
      </div>

      <button className="w-full px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-50 rounded-md hover:bg-primary-100 transition-colors whitespace-nowrap">
        Ver detalhes
      </button>
    </div>
  );
}